export const ALLOWED_ATTACHMENT_FILE_FORMATS = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
